import React from 'react';

import {ArchiveTableRowProps, getRowClassName} from 'archive/components/modals/ArchiveTableRowConstants';
import BenchlingConfig from 'BenchlingConfig';
import DataConnector from 'connect/DataConnector';
import {ContainerSummary} from 'constants/SampleConstants';
import {SampleControlsFeatureLevel} from 'inventory/sample-status/SampleControlsFeatureLevel';
import {hasMinimumSCRFeatureLevel} from 'inventory/sample-status/SampleControlsFeatureLevelUtil';
import SampleStatusLabel from 'inventory/sample-status/SampleStatusLabel';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import ShortcutIcon from 'ui-library/icons/ShortcutIcon';

interface EnhancedProps {
  container: ContainerSummary;
}

type Props = ArchiveTableRowProps & EnhancedProps;

class ContainerArchiveTableRowTypeDataConnector extends DataConnector<ArchiveTableRowProps, EnhancedProps> {
  enhanceProps(): EnhancedProps {
    return {
      container: this.getOrFetchRequired(
        ManagedModelType.STORABLE_SUMMARY,
        this.props.itemForArchive.id
      ) as ContainerSummary,
    };
  }
}

export function ContainerArchiveTableRowType({container, itemForArchive, options}: Props): JSX.Element {
  const IconClass = itemForArchive.isShortcut ? ShortcutIcon : BenchlingIcon;
  return (
    <div className={getRowClassName(itemForArchive, options)}>
      <IconClass className="faded" icon={itemForArchive.iconId} />
      <span className="u-small-spacing-left">{itemForArchive.friendlyTypeName}</span>
      <SampleStatusLabel
        className="u-small-spacing-left"
        item={container}
        includeAvailability={BenchlingConfig.INVENTORY_ENABLE_CHECK_IN_CHECK_OUT}
        includeAuthorization={hasMinimumSCRFeatureLevel(SampleControlsFeatureLevel.V1)}
        includeMessage={true}
        renderAllStatuses={false}
      />
    </div>
  );
}

export default ContainerArchiveTableRowTypeDataConnector.connect(ContainerArchiveTableRowType);
